module.exports = __webpack_public_path__ + "static/img/shower.604ac7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/img/shower.jpg
// module id = 507
// module chunks = 0